import type { ReactElement } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { storageName } from '../../../constans/auth';

const ProtectedRoute = (): ReactElement => {

    const dataUser: string | null = localStorage.getItem(storageName);
    const isAuth: boolean = !!dataUser;

    // Si no está autenticado, redirige al login
    if (!isAuth) {
        return <Navigate to="/login" replace />;
    }

    // Si está autenticado, renderiza las rutas hijas
    return <Outlet />;
};

export default ProtectedRoute;
